import {
	ChangeDetectionStrategy,
	Component,
	DestroyRef,
	EventEmitter,
	inject,
	Input,
	OnInit,
	Output,
} from '@angular/core';

import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'cmms-cost-input',
	imports: [MatInputModule, ReactiveFormsModule, NgxMaskDirective, NgxMaskPipe],
	templateUrl: './cmms-cost-input.component.html',
	styleUrls: ['./cmms-cost-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmmsCostInputComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);

	@Input() label = '';
	@Input() set value(value: number) {
		this.formControl.patchValue(value);
	}

	@Output() controlReady = new EventEmitter<FormControl>();
	@Output() valueChanged = new EventEmitter<number>();

	formControl = new FormControl(null);

	ngOnInit() {
		this.controlReady.emit(this.formControl);
		this.formControl.valueChanges
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(value => {
				if (!value) {
					this.formControl.setValue(null, { emitEvent: false });
				}
			});
	}

	emitValueChange() {
		this.valueChanged.emit(this.formControl.value);
	}
}
